module.exports = __webpack_public_path__ + "media/images/illustration-0717-2020-john-endicott-fc22946c65c366a33803d510f312bb4b.png";